@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.dimension {
  display: flex;
  align-items: center;
  min-width: 0;

  .dimension-input {
    display: flex;
    align-items: center;
    border: 1px solid @dimension-input--border-color;
    border-radius: 5px;
    min-width: 0;

    input {
      border: none;
    }
  }

  label {
    padding: 0 7px;
  }
}
